/**
 *   Name: MenuItems.js
 * Author: Francisco J. O'Meany
 * Description: Multiple menu items for all dashboard applications developed by Netequal Technology Solutions & Vysel
 *
 * Copyright (c) 2024 - Netequal Technology Solutions
 *
 */
import { FormattedMessage } from 'react-intl';
import Utility from '../Utility/Utility';
import jQuery from 'jquery';

export const Home = ( props ) => {
    const Utl = new Utility();
    const language = Utl.getCookie("appLang");
    const enterEmail = ( language === "en" ? "Enter email address" : "Escriba su correo electrónico" );
    const enterPwd = ( language === "en" ? "Enter your password" : "Escriba su contraseña" );
    const submitBtn = ( language === "en" ? "Submit" : "Enviar" );
    const resetBtn = ( language === "en" ? "Reset" : "Reajustar" );

    Utl.appLogger( "Home props: ", props );

    if( props.login.email === null ) {
      jQuery( "#appMenuItems" ).hide();
      Utl.appLogger( "Home props (empty): ", props );
    }

    const appTogglePwd = () => {
      let pwd = document.getElementById("usr_pwd");
      if (pwd.type === "password") {
        pwd.type = "text";
        jQuery( ".app-clear-pwd" ).addClass( "fa-eye-slash" ).removeClass( "fa-eye" );
        document.getElementById("usr_pwd").focus();
      } else {
        pwd.type = "password";
        jQuery( ".app-clear-pwd" ).addClass( "fa-eye" ).removeClass( "fa-eye-slash" );
        document.getElementById("usr_pwd").focus();
      }
    }

    return (
      <>
        <div className='row text-center'>
            <div className='col-lg-12'>
                <h1 className="header">
                    <FormattedMessage
                        id = "app-dash-welcome"
                        defaultMessage="WELCOME TO DASHBOARD TEMPLATE"
                    />
                </h1>
            </div>
        </div>
        <div className='row p-1 pb-0'>
            <div className='col-md-3'></div>
            <div className='col-md-6 text-center app-login-header'>
                <h3>
                  <FormattedMessage
                      id = "app-dash-login"
                      defaultMessage="Login"
                  />
                </h3>
            </div>
            <div className='col-md-3'></div>
        </div>

        { props.login.email === null && 
        <div id="appLoginScreen">
          <div className='container-flex'>
            <div className='row'>
              <div className='col-md-3'></div>
              <div className='col-md-6 app-login-box'>

                <form id="appLoginForm" className='mb-4'>

                  <div className='row form-group mt-4'>
                    <div className='col-md-4 text-end app-label-input'>
                        <span className='me-2'><strong>*</strong></span> 
                        <FormattedMessage
                          id = "app-dash-userid"
                          defaultMessage="User email"
                        />
                    </div>
                    <div className='col-md-8 text-start'>
                        <input type='email' name='usr_email' id='usr_email' placeholder={enterEmail} className='form-control' maxLength="64" />
                    </div>
                  </div>

                  <div className='row form-group mt-4'>
                    <div className='col-md-4 text-end app-label-input'>
                        <span className='me-2'><strong>*</strong></span> 
                        <FormattedMessage
                          id = "app-dash-password"
                          defaultMessage="Password"
                        />
                    </div>
                    <div className='col-md-8 text-start'>
                        <input type='password' name='usr_pwd' id='usr_pwd' placeholder={enterPwd} className='form-control d-inline' maxLength="16" />
                        <i className="far fa-eye fa-fw app-clear-pwd" aria-hidden="true" title="" onClick={appTogglePwd}></i>
                    </div>
                  </div>

                  <div className='row text-center mt-5 m-3'>
                    <div className='col-md-6 text-end app-login-button'>
                      <button type="button" id="appLoginBtn" className="app-submit-btn btn btn-primary disabled">{submitBtn}</button>
                    </div>

                    <div className='col-md-6 text-start app-login-button'>
                      <button type="button" id="appResetBtn" className="app-reset-btn btn btn-primary">{resetBtn}</button>
                    </div>
                  </div>

                  <div id="appLoginMsg" className='row mt-2'>
                    <div className='col-md-12'></div>
                  </div>
                </form>

              </div>
              <div className='col-md-3'></div>
            </div>
          </div>
        </div>
        }

      </>
    );
};

export function Dashboard() {
    return (
      <>
        <div className='row text-center'>
          <div className='col-lg-12'>
            <h1 className="text-uppercase">
              <FormattedMessage
                  id = "app-dash-dashboard"
                  defaultMessage="DASHBOARD"
              />
            </h1>
          </div>
        </div>
        <div className='row p-3'>
          <div className='col-lg-12'>
            <h3>
              
              <FormattedMessage
                  id = "app-dash-welcome-user"
                  defaultMessage="Welcome User"
              />
            </h3>
          </div>
        </div>
        <div className='row p-3'>
          <div className='col-lg-12'>
            <p>
                This tutorial discussed how to set up React Pro-Sidebar in our React application. We also discussed how to set up Material-UI icons and integrate the icons with the sidebar in our React app. React Pro-Sidebar has many advantages for building sidebars, such as great community, lightweight, documentation, customization properties, and consistency across the application.</p>
            <p>
                Also, we discussed how to implement menu and submenu items in our sidebar. We also looked at how to integrate our sidebar with React-Router.
            </p>
            <p>
                Furthermore, we looked at how to use the useProSidebar hook for extra functionalities like collapsing the sidebar and changing the texts and other elements in the sidebar to the right to left direction.
            </p>
            <p>
                React Pro-Sidebar is a valuable tool for creating functional sidebars to aid easy navigation and ensure a positive user experience in a React application.
            </p>

            <p>
                This tutorial discussed how to set up React Pro-Sidebar in our React application. We also discussed how to set up Material-UI icons and integrate the icons with the sidebar in our React app. React Pro-Sidebar has many advantages for building sidebars, such as great community, lightweight, documentation, customization properties, and consistency across the application.</p>
            <p>
                Also, we discussed how to implement menu and submenu items in our sidebar. We also looked at how to integrate our sidebar with React-Router.
            </p>
            <p>
                Furthermore, we looked at how to use the useProSidebar hook for extra functionalities like collapsing the sidebar and changing the texts and other elements in the sidebar to the right to left direction.
            </p>
            <p>
                React Pro-Sidebar is a valuable tool for creating functional sidebars to aid easy navigation and ensure a positive user experience in a React application.
            </p>

            <p>
                This tutorial discussed how to set up React Pro-Sidebar in our React application. We also discussed how to set up Material-UI icons and integrate the icons with the sidebar in our React app. React Pro-Sidebar has many advantages for building sidebars, such as great community, lightweight, documentation, customization properties, and consistency across the application.</p>
            <p>
                Also, we discussed how to implement menu and submenu items in our sidebar. We also looked at how to integrate our sidebar with React-Router.
            </p>
            <p>
                Furthermore, we looked at how to use the useProSidebar hook for extra functionalities like collapsing the sidebar and changing the texts and other elements in the sidebar to the right to left direction.
            </p>
            <p>
                React Pro-Sidebar is a valuable tool for creating functional sidebars to aid easy navigation and ensure a positive user experience in a React application.
            </p>
          </div>
        </div>
      </>
    );
  };
  
  
export function Transactions() {
    return (
      <>
        <h1 className="header">KEEP TRACK OF YOUR SPENDINGS</h1>
        <h3>Seamless Transactions</h3>
        <p>Lorem ipsum dolor sit amet...</p>
      </>
    );
  };    
